/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export enum RedirectType {
  URL,
  APP_STORE,
  ALARM_SUPPORT,
  HOME,
  GUIDE,
}

type RedirectProps = {
  type: RedirectType;
  url?: string;
  message?: string;
  timeoutSeconds?: number
}

export const Redirect: React.FC<RedirectProps> = React.memo(({type, url, message, timeoutSeconds = 0}) => {
  let { alarmId, pageName } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (timeoutSeconds) {
      setTimeout(redirect, timeoutSeconds * 1000);
     } else {
      redirect();
     }
  }, []);


  const redirect = () => {
    if (type === RedirectType.APP_STORE) {
      if ( navigator.userAgent.search( /Android/ )  > -1) {
        window.location.href = 'market://details?id=com.flotechnologies';
      } else if ( navigator.userAgent.search( /iPhone|iPod/ )  > -1 ){
        window.location.href = 'itms://itunes.apple.com/app/id1114650234';
      }
    } else if (type === RedirectType.ALARM_SUPPORT) {
      if (!alarmId || !pageName) { return; }
      let pageId = '';

      switch(~~alarmId){
        case 28:
        case 29:
        case 30:
        case 31:
          pageId = 'Small_Drip_Detected';
          break;
        case 13:
          pageId = 'Freeze_Warning';
          break;
        case 16:
          pageId = 'High_Water_Pressure';
          break;
        case 15:
          pageId = 'Low_Water_Pressure';
          break;
        case 22:
          pageId = 'General_System_Error';
          break;
        case 23:
          pageId = 'Device_Memory_Error';
          break;
        case 18:
          pageId = 'Valve_Error';
          break;
        case 33:
          pageId = 'Device_Offline';
          break;
        case 26:
          pageId = 'Extended_Water_Usage';
          break;
        case 11:
          pageId = 'High_Water_Usage';
          break;
        case 10:
          pageId = 'Fast_Water_Flow';
          break;
        case 51:
        case 52:
        case 53:
        case 37:
          pageId = 'Water_System_Shutoff';
          break;
        case 45:
          pageId = 'Alert_Resolved';
          break;
        case 32:
        case 39:
        case 40:
        case 41:
          pageId = 'Health_Test_Interrupted';
          break;
        case 5:
        case 34:
          pageId = 'Health_Test_Successful';
          break;
        case 55:
          pageId = 'Water_Use_in_AWAY_Mode';
          break;
        case 57:
          pageId = 'Water_Pressure_Over_Recommended_Max';
          break;
        case 4:
          pageId = 'Health_Test_Skipped';
          break;
        case 0:
        default:
          pageId = '';
          break;
      }
      window.location.href = `https://solutions.moen.com/Smart_Water_Security_Products/Help_Center/Flo_by_Moen_app/${pageId}`;
    } else if (type === RedirectType.HOME) {
      window.location.href = window.location.origin;
    } else if (type === RedirectType.GUIDE) {
      window.location.href = `${window.location.origin}/guide`;
    } else {
      window.location.href = url || '/';
    }
  };

  if (type === RedirectType.APP_STORE && navigator.userAgent.search( /Android|iPhone|iPod/ ) < 0 ) {
    return (
      <section>
        <h3>{t('visit_link_in_mobile')}</h3>
        <h3
          dangerouslySetInnerHTML={{
            __html: t('mobile-more-information', {addressLink: `<a href="https://meetflo.zendesk.com/hc/en-us/articles/230091847-Installing-the-Flo-Mobile-App">${t('flo-contact-support')}</a>`})
          }}
        >
        </h3>
      </section>
    );
  } else {
    return  (<section>{` ${message ? message : t('Redirecting')}... `}</section>);
  }
})

export default Redirect;
